import { useEffect, useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { LoadingState } from "@/components/common";
import { useGarage } from "@/context/GarageContext";
import { useFetch } from "@/lib/useFetch";
import { api, errMsg } from "@/lib/api";
import { t } from "@/i18n";

export function ChecklistTemplate() {
  const { canManage } = useGarage();
  const { data } = useFetch("/garage/checklist-template");
  const [items, setItems] = useState(null);
  useEffect(() => { if (data) setItems(data.items); }, [data]);
  if (!items) return <LoadingState />;
  const set = (i, patch) => setItems(items.map((x, j) => (j === i ? { ...x, ...patch } : x)));
  const save = async () => {
    try {
      const { data: d } = await api.put("/garage/checklist-template", { items: items.filter((x) => x.label.trim()) });
      setItems(d.items);
      toast.success(t("common.saved"));
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div className="space-y-3" data-testid="checklist-template">
      {items.map((x, i) => (
        <div key={x.id || i} className="flex gap-2">
          <Input value={x.section} disabled={!canManage} onChange={(e) => set(i, { section: e.target.value })} className="w-44" placeholder={t("checklist.section")} data-testid={`tpl-section-${i}`} />
          <Input value={x.label} disabled={!canManage} onChange={(e) => set(i, { label: e.target.value })} placeholder={t("checklist.item")} data-testid={`tpl-label-${i}`} />
          {canManage && <Button variant="ghost" size="icon" className="text-red-600" onClick={() => setItems(items.filter((_, j) => j !== i))} aria-label={t("common.remove")} data-testid={`tpl-remove-${i}`}><Trash2 className="h-4 w-4" /></Button>}
        </div>
      ))}
      {canManage && <div className="flex gap-2">
        <Button variant="outline" onClick={() => setItems([...items, { section: items.at(-1)?.section || "General", label: "" }])} data-testid="tpl-add"><Plus className="mr-1 h-4 w-4" /> {t("checklist.addItem")}</Button>
        <Button onClick={save} data-testid="tpl-save">{t("common.save")}</Button>
      </div>}
      <p className="text-xs text-slate-500">{t("checklist.templateNote")}</p>
    </div>
  );
}
